import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowRight, AlertCircle } from "lucide-react";
import { BrandTile } from "@/components/BrandTile";

export default function ResetPassword() {
  return (
    <div className="min-h-[100svh] w-full flex bg-background">
      <div className="w-full lg:w-1/2 flex flex-col justify-center px-8 sm:px-16 lg:px-24 xl:px-32">
        <div className="max-w-[360px] w-full mx-auto space-y-8 animate-in slide-in-from-left duration-500 fade-in">
          <div className="flex items-center gap-3">
            <BrandTile size="md" className="shadow-lg shadow-primary/25" />
            <h1 className="text-2xl font-bold font-display">Venda no Zap</h1>
          </div>

          <div className="space-y-6">
            <div className="flex flex-col items-center gap-4 py-8">
              <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
                <AlertCircle className="w-8 h-8 text-amber-600" />
              </div>
              <div className="text-center">
                <h2 className="text-2xl font-bold tracking-tight text-foreground">Link desatualizado</h2>
                <p className="text-muted-foreground mt-2">
                  O sistema de senhas foi substituído pelo login via link de acesso no WhatsApp. Agora é ainda mais fácil e seguro!
                </p>
              </div>
            </div>

            <Link href="/login">
              <Button className="w-full h-12 text-lg font-semibold group">
                Ir para o login <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <div className="hidden lg:block lg:w-1/2 relative bg-muted overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20 mix-blend-multiply z-10" />
        <img
          src={`${import.meta.env.BASE_URL}images/login-hero.png`}
          alt="E-commerce abstract illustration"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent z-10" />

        <div className="absolute bottom-16 left-16 right-16 z-20 text-foreground">
          <h3 className="text-4xl font-display font-bold leading-tight max-w-xl">
            A loja digital perfeita para o seu negócio no WhatsApp.
          </h3>
          <p className="mt-4 text-lg text-muted-foreground max-w-md">
            Receba pedidos organizados, fidelize clientes e aumente suas vendas sem pagar taxas abusivas.
          </p>
        </div>
      </div>
    </div>
  );
}
